import isEmpty from "lodash/isEmpty";

import Avatar from "@/ui/core/Avatar";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface MessagesAvatarGroupProps extends BaseViewProps {
  users?: BaseUserAvatarProps[];
}

enum AvatarGroupLayout {
  BorderWidth = 2,
  Size = 40,
}

const MessagesAvatarGroup = ({ testID, users }: MessagesAvatarGroupProps) => {
  if (isEmpty(users)) {
    return null;
  }

  const baseTestID = joinTestIDs(testID, "avatar-group");

  if (users?.length === 1) {
    const user = users[0];
    return (
      <Avatar
        imageUrl={user.imageUrl}
        testID={joinTestIDs(baseTestID, user.userId)}
        userName={user.userName}
        userType={user.userType}
      />
    );
  }

  const slicedUsers = users?.slice(0, 2);

  if (slicedUsers?.length === 2) {
    const user1 = slicedUsers[0];
    const user2 = slicedUsers[1];

    return (
      <Box
        height={AvatarGroupLayout.Size}
        position="relative"
        testID={baseTestID}
        width={AvatarGroupLayout.Size}
      >
        <Box bottom={0} left={0} position="absolute">
          <Avatar
            imageUrl={user1.imageUrl}
            size="xxs"
            testID={joinTestIDs(baseTestID, user1.userId)}
            userName={user1.userName}
            userType={user1.userType}
          />
        </Box>
        <Box
          borderColor={ColorToken.NeutralBackgroundPrimary}
          borderRadius={AvatarGroupLayout.Size / 2}
          borderWidth={AvatarGroupLayout.BorderWidth}
          position="absolute"
          right={-AvatarGroupLayout.BorderWidth}
          top={-AvatarGroupLayout.BorderWidth}
        >
          <Avatar
            imageUrl={user2.imageUrl}
            size="xxs"
            testID={joinTestIDs(baseTestID, user2.userId)}
            userName={user2.userName}
            userType={user2.userType}
          />
        </Box>
      </Box>
    );
  }

  // eslint-disable-next-line sonarjs/no-redundant-jump -- to enforce tsconfig's noImplicitReturn
  return;
};

export type { MessagesAvatarGroupProps };
export default MessagesAvatarGroup;
